import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/analysis_tool_analytics_events.py
export const ANALYSIS_TOOL_ANALYTICS_ACTIONS = {
  SELECTED_DATA_FRAME_CREATION_METHOD: {
    module: ANALYTICS_MODULE.ANALYSIS_TOOL,
    action: 'selected_data_frame_creation_option',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RESULTS_COLUMNS_MAPPED: {
    module: ANALYTICS_MODULE.ANALYSIS_TOOL,
    action: 'results_columns_mapped',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  /**
   * Action for clicking "Analysis key" button
   *
   * Analysis keys were originally specifc to steps and called analysis step keys. When we made this change
   * we chose to keep the event since it mostly represents the same action and will keep the data in the same
   * place.
   */
  COPIED_ANALYSIS_STEP_KEY: {
    module: ANALYTICS_MODULE.ANALYSIS_TOOL,
    action: 'copied_analysis_step_key',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SELECTED_SIDEBAR_ITEM: {
    module: ANALYTICS_MODULE.ANALYSIS_TOOL,
    action: 'selected_sidebar_item',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_GIVE_FEEDBACK: {
    module: ANALYTICS_MODULE.ANALYSIS_TOOL,
    action: 'clicked_give_feedback',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_FLOWCHART_ACTION: {
    module: ANALYTICS_MODULE.ANALYSIS_TOOL,
    action: 'clicked_flowchart_action',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
};
